import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M7.378 4.22a.787.787 0 0 1 1.091 0l7.457 7.25a.735.735 0 0 1 0 1.06L8.47 19.78a.787.787 0 0 1-1.09 0 .735.735 0 0 1 0-1.06L14.29 12 7.378 5.28a.735.735 0 0 1 0-1.06"
    }, null, -1)
  ]))]))
}
export default { render: render }